import * as React from 'react';
import { useState, useEffect, useRef } from "react";
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import ButtonGroup from '@mui/material/ButtonGroup';
import DraggableComponent from "./DraggableComponent"
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Divider from '@mui/material/Divider';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import { useContext } from "react";
import MainContext from "../../context/mainContext";
import { customToastify } from "../pages/utils/utilsFunctions"
import SyncIcon from '@mui/icons-material/Sync';
import Fab from '@mui/material/Fab';
import { Checkbox } from "@mui/material";
import FormControlLabel from '@mui/material/FormControlLabel';

export default function SynchronizeSubtitles({ compareSubtitlesBoxData, videoRef, playSyncTwoSub, handlePlaySyncTwoSub,subtitlesTimeShift,handleSubtitlesTimeShift }) {
    const {
        handleSubtitleTimeShiftBox,
        subtitleTimeShiftBox,
        videoInfo
    } = useContext(MainContext);
    const [subtitlesOneFile, setSubtitlesOneFile] = React.useState(0);
    const [subtitlesTwoFile, setSubtitlesTwoFile] = React.useState(0);
    const [useAutoSyncTime, setUseAutoSyncTime] = React.useState(0);
    const [useCompareBox, setUseCompareBox] = React.useState({ subOne: false, subTwo: false });

    const handleSubtitlesOneTimeShift = (time) => {
        const newTime = (subtitlesTimeShift["one"] * 10 + time * 10) / 10
        handleSubtitlesTimeShift(1,newTime)
        setTime(1, time)
    }
    const handleSubtitlesTwoTimeShift = (time) => {
        const newTime = (subtitlesTimeShift["two"] * 10 + time * 10) / 10
        handleSubtitlesTimeShift(2,newTime)
        setTime(2, time)
    }

    const automaticSyncTime = () => {
        let trackOne = document.querySelector(`#subtitlesOneTrack`)
        let trackTwo = document.querySelector(`#subtitlesTwoTrack`)
        if (!trackOne || !trackTwo) customToastify("error", "برای همزمان سازی اتوماتیک باید دو زیرنویس انتخاب شده باشند");
        if (videoRef["current"]["props"]["playing"]) customToastify("error", "لطفا ایتدا فیلم را متوقف کنید");
        else if (trackOne.track.activeCues.length == 0) customToastify("error", "هیچ دیالوگ فعالی در زیرنویس اول وجود ندارد");
        else if (trackTwo.track.activeCues.length == 0) customToastify("error", "هیچ دیالوگ فعالی در زیرنویس دوم وجود ندارد");
        else if (useAutoSyncTime == trackOne.track.activeCues[0]["startTime"]) customToastify("error", "برای استفاده دوباره از همزمان سازی اتوماتیک باید فیلم پخش و چند زیرنویس مشاهده شده باشد");
        else {
            setUseAutoSyncTime(trackOne.track.activeCues[0]["startTime"])
            const diffTime = (trackOne.track.activeCues[0]["startTime"] * 10 - trackTwo.track.activeCues[0]["startTime"] * 10) / 10
            handleSubtitlesTwoTimeShift(parseFloat(diffTime.toFixed(2)))
        }
    }
    const setTime = (subNumber, time) => {
        const video = document.querySelector("video")
        let floatTime = parseFloat(time)
        if (video) {
            let textTracks = subNumber == 1 ? video.textTracks[0] : video.textTracks[1]
            if (textTracks) Array.from(textTracks.cues).forEach((cue) => {
                cue.startTime += floatTime;
                cue.endTime += floatTime;
            });
        }
    }
    useEffect(() => {
        if (subtitlesOneFile !== videoInfo["subtitleOneFile"]) {
            setSubtitlesOneFile(videoInfo["subtitleOneFile"])
            if (!useCompareBox["subOne"]) handleSubtitlesTimeShift(1,0)
        }
        if (subtitlesTwoFile !== videoInfo["subtitleTwoFile"]) {
            setSubtitlesTwoFile(videoInfo["subtitleTwoFile"])
            if (!useCompareBox["subTwo"]) handleSubtitlesTimeShift(2,0)
        }
        if (useCompareBox["subOne"] || useCompareBox["subTwo"]) setUseCompareBox({ subOne: false, subTwo: false })
    }, [subtitleTimeShiftBox])
    useEffect(() => {
        if (compareSubtitlesBoxData["newData"]) {
            let compareBox = { subOne: false, subTwo: false }
            if (compareSubtitlesBoxData["subOne"]) {
                if (compareSubtitlesBoxData["subOne"]["timeShift"] !== 0) {
                    handleSubtitlesTimeShift(1,compareSubtitlesBoxData["subOne"]["timeShift"])
                    compareBox["subOne"] = true
                }
            }
            if (compareSubtitlesBoxData["subTwo"]) {
                if (compareSubtitlesBoxData["subTwo"]["timeShift"] !== 0) {
                    handleSubtitlesTimeShift(2,compareSubtitlesBoxData["subTwo"]["timeShift"])
                    compareBox["subTwo"] = true
                }
            }
            setUseCompareBox(compareBox)
        }
    }, [compareSubtitlesBoxData])
    return (
        <DraggableComponent maxWidth={"70%"} >
            <Paper sx={{ display: subtitleTimeShiftBox ? "block" : "none" }} >
                <Box >
                    <Paper sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                        <Fab color="primary" variant="extended" size="small" onClick={() => { automaticSyncTime() }} >
                            <SyncIcon /> auto
                        </Fab>
                        <Typography>تنظیم زمان زیرنویس ها </Typography>
                        <Button variant="contained" color='error' size='small' onClick={() => {
                            handleSubtitleTimeShiftBox(false)
                        }}>بستن</Button>
                    </Paper>

                    <Divider />
                    <ButtonGroup sx={{ m: 0, p: 0 }} variant="contained" aria-label="Basic button group">
                        {/* <Typography sx={{ backgroundColor: "white", color: "black", borderRadius: "10px 10px 0px 0px", m: 0, p: 0 }}>1</Typography> */}
                        <Paper sx={{ px: 1 }}>1:</Paper>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesOneTimeShift(1) }}><LocalHospitalIcon sx={{ m: 0, p: 0 }} />1s</Button>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesOneTimeShift(0.1) }}> <LocalHospitalIcon sx={{ m: 0, p: 0 }} />0.1s</Button>
                        <Typography sx={{ backgroundColor: "white", color: "black", width: "50px" }}>{subtitlesTimeShift["one"]}</Typography>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesOneTimeShift(-0.1) }}>0.1s<IndeterminateCheckBoxIcon sx={{ m: 0, p: 0 }} /></Button>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesOneTimeShift(-1) }}>1s<IndeterminateCheckBoxIcon sx={{ m: 0, p: 0 }} /></Button>
                    </ButtonGroup>
                    <Divider />
                    {/* <Typography sx={{ backgroundColor: "white", color: "black", borderRadius: "10px 10px 0px 0px", m: 0, p: 0 }}>زیرنویس دوم(ثانیه)</Typography> */}
                    <ButtonGroup sx={{ m: 0, p: 0 }} variant="contained" aria-label="Basic button group">
                        <Paper sx={{ px: 1 }}>2:</Paper>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesTwoTimeShift(1) }}> <LocalHospitalIcon sx={{ m: 0, p: 0 }} />1s</Button>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesTwoTimeShift(0.1) }}> <LocalHospitalIcon sx={{ m: 0, p: 0 }} />0.1s</Button>
                        <Typography sx={{ backgroundColor: "white", color: "black", width: "50px" }}>{subtitlesTimeShift["two"]}</Typography>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesTwoTimeShift(-0.1) }}>0.1s<IndeterminateCheckBoxIcon sx={{ m: 0, p: 0 }} /></Button>
                        <Button sx={{ textTransform: "lowercase", py: 0.1, px: 0.4, m: 0 }} onClick={() => { handleSubtitlesTwoTimeShift(-1) }}>1s<IndeterminateCheckBoxIcon sx={{ m: 0, p: 0 }} /></Button>
                    </ButtonGroup>
                </Box>
                <FormControlLabel
                    sx={{
                        display: "flex",
                        flexDirection: "colum",
                        fontSize: "small"
                    }}
                    onChange={(e) => {
                        handlePlaySyncTwoSub(e.target.checked);
                    }}
                    name="subtitleTwoOff"
                    control={
                        <Checkbox checked={playSyncTwoSub} color="error" />
                    }
                    label="نمایش زیرنویس فقط در پخش همزمان"
                />
            </Paper>
        </DraggableComponent>
    );
}